<template>
    <div class="page-wrap" v-loading="loading">
        <div class="landing-shell">
            <img class="hero-img" :src="heroImg" alt="hero" />

            <section class="consent-block">
                <img class="step-label" :src="phoneLabelImg" alt="step label" />
                <div class="phone-input-wrap">
                    <input
                        v-model.trim="mobile"
                        class="phone-input"
                        type="tel"
                        maxlength="11"
                        inputmode="numeric"
                        placeholder="请填写手机号"
                    />
                </div>
                <div class="agree-row">
                    <span class="agree-icon">✓</span>
                    <span>
                        提交视为阅读和同意
                        <button class="rule-link" type="button" @click="openRulePage">《用户服务条款及隐私政策》</button>
                    </span>
                </div>
                <button class="confirm-btn" type="button" @click="onOpen">
                    <img class="confirm-gif" :src="receiveButtonImg" alt="登录领取" />
                </button>
            </section>

            <section class="below-content">
                <div class="benefits-wrap">
                    <img class="benefits-image" :src="memberBenefitsImg" alt="member benefits" />
                    <div class="price-line">资费： {{ priceText }}元/月（30天）</div>
                </div>
                <div class="rules-banner">
                    <img class="rules-banner-img" :src="rulesBgImg" alt="rules background" />
                    <div class="rules-banner-text">
                        <div class="rules-copy">
                            <p>活动对象：2G/3G/4G/5G 手机用户</p>
                            <p>本页面仅供客户购买订阅权益，非用于鉴权登录等其他服务。老年人及未成年人请谨慎消费，敬请知悉！为保障您的权益，请仔细核实订购规则及订单详情，切勿轻信陌生人通过网络、电话、短信告知的相关信息，谨防电信网络诈骗。</p>
                            <p>一、订购规则</p>
                            <p>1. 月月自由领产品（以下简称<span class="rule-emphasis">本产品</span>）当前支持移动、联通、电信三网用户办理。</p>
                            <p>2. 同一用户仅限参与一次活动。用户授权签约开通服务后，可获赠最低 4 折品牌优惠购服务，用户拥有充分时间确认是否订购该产品。中途如未取消签约，则视为您同意订购该产品，系统将在 48 小时内进行自动扣费。用户如中途想要取消签约，会核减使用过程中产生的权益费用后再做退款。本产品资费49.9元/周期，每30个自然日为一个会员周期，订购成功随即扣除当前会员周期费用。</p>
                            <p>3. 如无退订操作，本产品默认自动续订，最长自动续约周期为 12 个月（含开通当月）。每一轮会员周期开始当日 0 点起至该周期最后一天 0 点，将从会员绑定手机号对应的支付宝账户中自动扣除当期会员费。</p>
                            <p>4. 本产品用户申请退订后，可继续享用会员权益至当前会员周期最后一天，到期后不再自动续费。</p>
                            <p>5. 本产品输入手机号码即可办理，请仔细核对办理号码，一旦办理成功，号码无法更改退换。</p>
                            <p>6. 业务办理生效受网络、系统等因素影响可能存在延时，会员生效状态以页面实际展示为准。</p>
                            <p>二、使用规则</p>
                            <p>1. 每个会员周期内用户可获得两次【热门APP会员月卡】领取机会，若当前周期内未领取，领取机会将于周期最后一天 23:59:59 自动失效。注：【热门APP会员月卡】需用户手动领取。</p>
                            <p>1.1【热门APP会员月卡】领取流程：用户打开绑定手机号对应的支付宝账号，搜索小程序：<span class="rule-emphasis">自由领权益领取中心 - 盈思生活</span>，进入小程序界面，授权对应下单手机号登录，点击<span class="rule-emphasis">权益领取界面</span>，选择【<span class="rule-emphasis">文娱会员任选</span>】界面，按需选择两款热门APP会员月卡，点击领取。领取成功后前往对应APP使用领取手机号登录即可使用。</p>
                            <p>1.2 每个周期内已领取成功的会员权益不支持更换，请确认所需会员后再操作领取；领取到的会员权益按照对应权益页面规则使用。</p>
                            <p>2. 每个会员周期内用户可无限次使用【优惠权益】</p>
                            <p>2.1【优惠权益】使用：用户打开绑定手机号对应的支付宝账号，搜索小程序：<span class="rule-emphasis">自由领权益领取中心 - 盈思生活</span>，进入小程序界面，授权对应下单手机号登录，点击<span class="rule-emphasis">权益领取界面</span>，选择【<span class="rule-emphasis">权益优惠区</span>】界面，可按需选择对应平台享受优惠点餐或订购服务。</p>
                            <p>三、会员退订</p>
                            <p>1. 本产品支持随时退订。退订后，当期会员权益可正常使用至当前会员周期最后一天 23:59:59，次日会员失效，不再产生扣费。</p>
                            <p>2. 退订方式：进入支付宝 → 我的 → 设置 → 支付设置 → 自动续费/免密支付，选择对应的签约服务点击关闭服务，确认关闭。</p>
                            <p>四、退款政策</p>
                            <p>1. <span class="rule-emphasis">可退款情形</span></p>
                            <p>① 用户在签约后、48 小时扣费窗口期内主动取消签约，平台将核减已经实际消耗的权益费用后办理退款；② 因平台系统故障、业务办理异常，导致用户未实际获得对应会员权益的，可申请当期订单退款。</p>
                            <p>2. <span class="rule-emphasis">不予退款情形</span></p>
                            <p>① 会员周期已扣费生效，用户已领取文娱会员权益，或已使用优惠权益的，不支持全额退款；② 超过当前会员周期的历史订单，不予受理退款申请；③ 存在恶意下单、套利、倒卖权益、虚假申请退款等违规行为，平台有权直接驳回退款申请。</p>
                            <p>3. <span class="rule-emphasis">退款计算规则</span></p>
                            <p>· 未使用任何权益：退还该周期实付 49.9 元；</p>
                            <p>· 已部分使用权益：退款金额 = 实付金额 - 已使用权益对应的折算费用；</p>
                            <p>· 优惠抵扣部分不折现、不退款，仅退回用户实际现金支付部分。</p>
                            <p>4. <span class="rule-emphasis">退款方式与时效</span> ① 退款优先采用<span class="rule-emphasis">原路退回</span>，退还至原支付的支付宝账户；若原路退款失败，用户需配合提供实名收款材料进行核实处理；② 用户提交退款申请后，平台将在1个工作日内完成审核；审核通过后发起退款，资金到账时间以支付宝渠道处理时效为准；③ 退款申请可联系小程序在线客服或者拨打客服热线 4009966049 提交。</p>
                            <p>5. <span class="rule-emphasis">其他说明</span> 退款成功仅代表该笔订单资金结清，不视为平台承认存在违约。因用户提供收款信息错误造成退款失败，相关责任由用户自行承担。</p>
                            <p>五、特别说明</p>
                            <p>本产品权益内容以页面实时展示为准，平台可根据用户体验优化调整权益，但保证用户已支付对价对应的权益价值不降低。权益发生调整的，将提前 7 个工作日在活动页面公示告知用户。</p>
                            <p>六、客服服务</p>
                            <p>如对活动有疑问或其他需求，请咨询在线客服或者拨打客服热线：4009966049。</p>
                        </div>
                    </div>
                </div>
                <button class="confirm-btn confirm-btn-bottom" type="button" @click="onOpen">
                    <img class="confirm-gif" :src="receiveButtonImg" alt="登录领取" />
                </button>
            </section>
            <div ref="bottomSentinel" class="confirm-spacer"></div>
        </div>

        <el-dialog title="用户服务条款及隐私政策" :visible.sync="privacyVisible" width="90%" top="10vh">
            <div class="dialog-content">
                <p>提交视为阅读和同意《用户服务条款及隐私政策》。</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" round @click="privacyVisible = false">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
const API_BASE_URL = 'https://zfbxcxht.yingsi0221.com'

export default {
    name: 'ThirdPage',
    data() {
        return {
            loading: false,
            privacyVisible: false,
            mobile: '',
            buttonFixed: false,
            priceText: '49.8',
            alipayAppId: '',
            heroImg: require('@/assets/images/hero.png'),
            phoneLabelImg: require('@/assets/images/phone-label.gif'),
            receiveButtonImg: require('@/assets/images/receive-button.gif'),
            memberBenefitsImg: require('@/assets/images/member-benefits.png'),
            rulesBgImg: require('@/assets/images/rules-bg.png')
        }
    },
    mounted() {
        this.handleScroll = () => {
            const sentinel = this.$refs.bottomSentinel
            if (!sentinel) return
            const rect = sentinel.getBoundingClientRect()
            const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0
            this.buttonFixed = rect.top <= viewportHeight - 80
        }
        window.addEventListener('scroll', this.handleScroll, { passive: true })
        window.addEventListener('resize', this.handleScroll, { passive: true })
        this.$nextTick(() => this.handleScroll())
        this.fetchLandingConfig()
        this.fetchAlipayAppId()
    },
    beforeDestroy() {
        if (this.handleScroll) {
            window.removeEventListener('scroll', this.handleScroll)
            window.removeEventListener('resize', this.handleScroll)
        }
    },
    methods: {
        async fetchLandingConfig() {
            const domain = window.location.hostname
            if (!domain) return

            try {
                this.loading = true
                const urls = [
                    `https://zfbxcxht.yingsi0221.com/common/landingConfig?domain=${encodeURIComponent(domain)}`
                ]

                for (const url of urls) {
                    try {
                        const resp = await fetch(url, { method: 'GET' })
                        const data = await resp.json()
                        const config = data && data.data ? data.data : {}
                        const price = config.pageBAmountYuan || config.price
                        if (resp.ok && price) {
                            this.priceText = price
                            return
                        }
                    } catch (e) {
                        // try next url
                    }
                }
            } catch (error) {
                console.error('获取落地页配置失败', error)
            } finally {
                this.loading = false
            }
        },
        async fetchAlipayAppId() {
            try {
                const urls = [
                    'https://zfbxcxht.yingsi0221.com/system/config/configKey/alipay.appId'
                ]

                for (const url of urls) {
                    try {
                        const resp = await fetch(url, { method: 'GET' })
                        const data = await resp.json()
                        const appId = data && data.data
                        if (resp.ok && appId) {
                            this.alipayAppId = appId
                            return
                        }
                    } catch (e) {
                        // try next url
                    }
                }
            } catch (error) {
                console.error('获取支付宝 appId 失败', error)
            }
        },
        getDefaultAlipayAppIdByDomain() {
            const domain = window.location.hostname
            const appIdMap = {
                'vip.winihao.top': '2021006162661316',
                'vip.dingxindun.com': '2021006162625180',
                'vip.xinghuilg.com': '2021006162645006',
                'zfbxcxht.yingsi0221.com': '2021006104667544',
                'vip.yzxh01.com': '2021006135640943'
            }
            return appIdMap[domain] || '2021006135640943'
        },
        getAlipayJumpUrl() {
            const appId = this.alipayAppId && String(this.alipayAppId).trim()
                ? this.alipayAppId
                : this.getDefaultAlipayAppIdByDomain()
            return `alipays://platformapi/startapp?appId=${appId}`
        },
            async onOpen() {
            if (!/^1\d{10}$/.test(this.mobile)) {
                this.$message.warning('请输入正确的手机号')
                return
            }
            if (this.loading) return

            this.loading = true
            try {
                const response = await fetch(`${API_BASE_URL}/api/antom/consult`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
                    body: JSON.stringify({
                        phone: this.mobile,
                        customerBelongsTo: 'ALIPAY_CN',
                        terminalType: 'WAP'
                    })
                })
                const result = await response.json()
                if (!response.ok || result.code !== 200 || !result.data || !result.data.authorizationUrl) {
                    throw new Error(result.msg || result.message || '授权初始化失败')
                }
                localStorage.setItem('antom_order_no', result.data.orderNo)
                localStorage.setItem('antom_phone', this.mobile)
                window.location.href = result.data.authorizationUrl
            } catch (error) {
                console.error('Antom授权初始化失败', error)
                this.$message.error(error.message || '授权初始化失败，请稍后重试')
            } finally {
                this.loading = false
            }
        },
        openRulePage() {
            this.$router.push('/rule-page')
        }
    }
}
</script>

<style scoped>
.page-wrap {
    min-height: 100vh;
    height: 100vh;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    background: #ef612f;
}
.landing-shell {
    min-height: 100vh;
    padding: 0 0 28px;
    box-sizing: border-box;
}
.hero-img {
    width: 100%;
    display: block;
}
.consent-block {
    margin: 0 12px;
    margin-top: 0;
    padding-top: 6px;
}
.step-label {
    width: 152px;
    display: block;
    margin: 0 0 8px 22px;
}
.phone-input-wrap {
    padding: 18px 20px;
    border-radius: 999px;
    background: #fff;
    margin: 0 0 8px;
}
.phone-input {
    width: 100%;
    border: none;
    outline: none;
    background: transparent;
    font-size: 18px;
    color: #333;
}
.phone-input::placeholder {
    color: #9d9d9d;
}
.agree-row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: #d6c58b;
    font-size: 12px;
    line-height: 1.2;
    margin-top: 4px;
    text-align: center;
}
.agree-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #d8c88a;
    color: #fff;
    font-size: 12px;
    flex-shrink: 0;
}
.rule-link {
    border: none;
    background: transparent;
    padding: 0;
    color: inherit;
    font: inherit;
    text-decoration: none;
}
.confirm-btn {
    width: calc(100% - 24px);
    border: none;
    background: transparent;
    padding: 0;
    display: block;
    margin: 22px auto 0;
}
.confirm-btn-fixed {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 10px;
    z-index: 20;
    max-width: calc(100% - 24px);
    transition: opacity 0.2s ease, transform 0.2s ease;
    opacity: 1;
}
.confirm-btn-bottom {
    margin: 28px auto 0;
}
.confirm-gif {
    width: 100%;
    display: block;
}
.confirm-spacer {
    height: 4px;
}
.price-line {
    position: absolute;
    left: 50%;
    top: 6px;
    transform: translateX(-50%);
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.2px;
    white-space: nowrap;
    background: linear-gradient(180deg, #fff6d8 0%, #f4d27a 45%, #d5ab53 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
}
.below-content {
    margin-top: 18px;
    padding: 0 12px 30px;
}
.benefits-wrap {
    position: relative;
}
.benefits-image {
    width: 100%;
    display: block;
    border-radius: 18px;
    box-shadow: 0 10px 22px rgba(0,0,0,0.08);
}
.section-title {
    margin: 18px 2px 10px;
    font-size: 18px;
    font-weight: 900;
    color: #fff;
}
.rules-banner {
    position: relative;
    margin-top: 14px;
    border-radius: 18px;
    overflow: hidden;
    background: #f7d889;
}
.rules-banner-img {
    width: 100%;
    height: auto;
    position: absolute;
    inset: 0;
}
.rules-banner-text {
    position: relative;
    padding: 123px 14px 28px;
    box-sizing: border-box;
}
.rules-copy {
    color: #4a2a16;
    line-height: 1.78;
    font-size: 12px;
    text-align: left;
}
.rules-copy p {
    margin: 0 0 12px;
}
.rules-copy p:first-child {
    font-size: 13px;
    font-weight: 700;
    margin-bottom: 14px;
}
.rules-copy p:nth-child(3),
.rules-copy p:nth-child(10),
.rules-copy p:nth-child(15),
.rules-copy p:nth-child(18),
.rules-copy p:nth-child(25),
.rules-copy p:nth-child(36) {
    margin-top: 8px;
}
.rule-emphasis {
    font-weight: 700;
}
.footer-note {
    margin-top: 16px;
    padding: 16px 14px 10px;
    text-align: center;
    color: rgba(255,255,255,0.86);
    font-size: 12px;
    line-height: 1.8;
}
.notice-strip {
    margin-top: 14px;
    padding: 14px 14px;
    border-radius: 18px;
    background: linear-gradient(180deg, rgba(255,255,255,0.16), rgba(255,255,255,0.08));
    color: #fff;
    text-align: center;
    line-height: 1.7;
}
.notice-strip .notice-title {
    font-size: 18px;
    font-weight: 900;
}
.notice-strip .notice-desc {
    margin-top: 6px;
    font-size: 13px;
    opacity: 0.92;
}
.faq-list {
    display: grid;
    gap: 12px;
}
.faq-item {
    border-radius: 18px;
    padding: 14px;
    background: rgba(255,255,255,0.95);
    color: #333;
    box-shadow: 0 10px 22px rgba(0,0,0,0.08);
}
.faq-q {
    font-weight: 800;
    color: #111;
    margin-bottom: 8px;
}
.faq-a {
    font-size: 13px;
    line-height: 1.65;
    color: #555;
}
.footer-note {
    margin-top: 16px;
    padding: 16px 14px 10px;
    text-align: center;
    color: rgba(255,255,255,0.86);
    font-size: 12px;
    line-height: 1.8;
}
.dialog-content {
    text-align: center;
    line-height: 1.8;
    color: #444;
}
.dialog-footer { display: block; text-align: center; }
</style>
